export default __webpack_public_path__ + "static/media/entry.00a03c9a.svg";